import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import cn from "classnames";
import styles from "./FormationCreate.module.sass";
import { Link } from "react-router-dom";
import Icon from "../../components/Icon";

// Screens
import FormationInformations from "./FormationInformations";
import ResponsableInformations from "./ResponsableInformations";
import CentreInformations from "./CentreInformations";
import AddressInformations from "./AddressInformations";
import CostsInformations from "./CostsInformations";
import ConventionInformations from "./ConventionInformations";

// Services
import { createFormation } from "../../services/formation.service";
import { showSuccess, showError } from "../../services/toast.service";

const FormationCreate = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [formationData, setFormationData] = useState({});

  // Gestionnaire pour les changements de champs de formation
  const handleFormationChange = (event) => {
    const { name, value } = event.target;
    setFormationData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Gestionnaire pour les dropdowns
  const handleDropdownChange = (fieldName, value) => {
    setFormationData(prev => ({
      ...prev,
      [fieldName]: value
    }));
  };

  // Gestionnaire pour la sélection du centre
  const handleSelectCenter = (center) => {
    setFormationData(prev => ({
      ...prev,
      center_id: center?.id || null,
      // Si place_Identical_training est activé et qu'on a des données d'adresse
      ...(prev.place_Identical_training && center?.addressData ? center.addressData : {})
    }));
  };

  // Gestionnaire pour le switch
  const handleSwitchChange = (fieldName, value) => {
    setFormationData(prev => ({
      ...prev,
      [fieldName]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      // Conversion des valeurs numériques et boolean
      const formationToSave = {
        ...formationData,
        numberOfAccommodations: formationData.numberOfAccommodations ? parseInt(formationData.numberOfAccommodations) : null,
        numberOfMeals: formationData.numberOfMeals ? parseInt(formationData.numberOfMeals) : null,
        // S'assurer que les boolean sont bien des boolean
        fraisHebergement: Boolean(formationData.fraisHebergement),
        fraisRestauration: Boolean(formationData.fraisRestauration),
        amountOfInitialEquipment: Boolean(formationData.amountOfInitialEquipment),
        mentionOfInternationalMobility: Boolean(formationData.mentionOfInternationalMobility)
      };

      console.log('Données de formation à envoyer:', formationToSave);
      await createFormation(formationToSave);
      showSuccess("Formation créée avec succès!");
      navigate("/admin/formations/");
    } catch (err) {
      const errorMessage =
        "Impossible de créer la formation: " +
        (err.message || "Veuillez vérifier les informations saisies.");
      showError(errorMessage);
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className={styles.container}>
        <Link className={cn("button-white", styles.button)} to="/admin/formations/">
          <Icon name="arrow-left" />
          Retour
        </Link>

        <div className={styles.background}>
          <img src="/images/content/bg-shop.jpg" alt="Background" />
        </div>

        <div className={styles.formContainer}>
          {error && <div className={styles.error}>{error}</div>}
          <form onSubmit={handleSubmit}>
            <FormationInformations
              formation={formationData}
              onFormationChange={handleFormationChange}
              onDropdownChange={handleDropdownChange}
              loading={loading}
            />
            <CostsInformations
              formation={formationData}
              onFormationChange={handleFormationChange}
              loading={loading}
            />
            <ResponsableInformations
              formation={formationData}
              onFormationChange={handleFormationChange}
              loading={loading}
            />
            <CentreInformations
              formation={formationData}
              onSelectCenter={handleSelectCenter}
              onSwitchChange={handleSwitchChange}
              onSubmit={handleSubmit}
              loading={loading}
            />
            <AddressInformations
              formation={formationData}
              onFormationChange={handleFormationChange}
              loading={loading}
              visible={!formationData.place_Identical_training}
              onSubmit={handleSubmit}
            />
            <ConventionInformations
              formation={formationData}
              onFormationChange={handleFormationChange}
              onDropdownChange={handleDropdownChange}
              loading={loading}
              onSubmit={handleSubmit}
            />
          </form>
        </div>
      </div>
    </>
  );
};

export default FormationCreate;
